/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/destructuring-assignment */
import { useState } from "react";

import Popper from "@mui/material/Popper";
import InfoIcon from "@mui/icons-material/Info";

interface IProps {
  message: any;
}
const InfoPopper = (props: IProps) => {
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null as HTMLElement | null);

  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
        onMouseEnter={(event) => {
          setOpen(true);
          setAnchorEl(event.currentTarget);
        }}
        onMouseLeave={() => {
          setOpen(false);
          setAnchorEl(null);
        }}
      >
        <InfoIcon style={{ fontSize: 22, color: "#00A0DF" }} />
      </div>
      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="top-start"
        // style={{ zIndex: 1, marginRight: 10, paddingBottom: 50 }}
      >
        <div
          style={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: 8,
            padding: 10,
            fontSize: 14,
            border: "3px solid #D9D9D9",
            zIndex: 20,
          }}
        >
          <div style={{ width: "100%" }}>{props.message}</div>
        </div>
      </Popper>
    </div>
  );
};

export default InfoPopper;
